<ion-header collapse="fade">
  <ion-toolbar>
    <ion-title role="heading" aria-level="1" mode="md">
      {{ 'page.feed.title' | translate }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="openFilter()"
        [attr.aria-label]="'feed.filter' | translate"
        *ngIf="categories"
      >
        <ion-icon
          color="dark"
          slot="icon-only"
          aria-hidden="true"
          src="/assets/icons/filter.svg"
        ></ion-icon>
      </ion-button>
      <ion-button
        (click)="openNotifications()"
        role="link"
        [attr.aria-label]="('page.notifications' | translate) + ', ' + notificationCount + ' ' + ('notifications.new' | translate)"
      >
        <ion-icon
          color="dark"
          slot="icon-only"
          aria-hidden="true"
          src="/assets/icons/notifications.svg"
        ></ion-icon>
        <span aria-hidden="true" *ngIf="notificationCount > 0"
          >{{ notificationCount }}</span
        >
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content
  class="ion-padding"
  #contentRef
  [scrollEvents]="true"
  (ionScrollEnd)="onScrollEnd()"
>
  <div class="app__content feed">
    <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <div class="feed-content" *ngIf="categories">
      <app-card
        *ngFor="let eventCard of eventCards"
        [project]="eventCard.project"
        [events]="eventCard.events"
        [withHeader]="true"
        className="card--events"
        [type]="CardType.EVENTS"
        [withFollowers]="false"
      >
      </app-card>
      <ng-container *ngFor="let item of feed; let i = index">
        <app-feed-item
          (itemVisible)="onItemVisible($event)"
          (deleted)="removeItem($event)"
          [item]="item"
          (blockMoving)="blockRefresh($event)"
          [likedType]="updateDeviceData[item.projectUpdate?.id]?.likedType"
        ></app-feed-item>
        <app-project-suggestion-slider
          *ngIf="(i === 1 || feed?.length === 1) && !isProjectApp"
          [title]="'project-suggestion.title'"
        ></app-project-suggestion-slider>
      </ng-container>
      <p
        class="notice"
        *ngIf="loadingFinished && feed?.length > 0 && feed?.length == totalItems"
      >
        {{ 'feed.end' | translate }}
      </p>
      <p
        class="notice"
        *ngIf="loadingFinished && !loading && feed?.length == 0 && !activeCategory"
      >
        {{ 'feed.empty' | translate }}
      </p>
      <p
        class="notice"
        *ngIf="loadingFinished && !loading && feed?.length == 0 && activeCategory"
      >
        {{ 'feed.filter.empty' | translate }}
      </p>
    </div>
    <ion-infinite-scroll
      [hidden]="feed?.length == totalItems"
      (ionInfinite)="loadFeed($event)"
    >
      <ion-infinite-scroll-content></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </div>
  <app-loader
    [full]="true"
    [loading]="!loadingFinished || loading"
    [hidden]="feed?.length > 0"
  ></app-loader>
</ion-content>
